<template>
    <div
        class="mt-3"
        data-testid="price-breakdown-row"
    >
        <div class="flex items-baseline justify-between gap-4">
            <!-- Every name takes the figure's darker colour, so a description beneath it reads as a
                 note under a heading rather than another line. Line items are medium weight. -->
            <div
                class="text-muval-gray-1"
                :class="[textSize, { 'font-medium': row.lineItem }]"
                data-testid="price-breakdown-row-label"
            >
                {{ row.label }}
            </div>
            <div
                class="shrink-0 text-right"
                :class="[
                    textSize,
                    row.muted ? 'text-muval-gray-2 italic' : 'text-muval-gray-1',
                    { 'font-medium': row.lineItem },
                ]"
                data-testid="price-breakdown-row-value"
            >
                {{ row.value }}
            </div>
        </div>
        <!-- Plain text by interpolation, never v-html: staff type these, and the customer reads them.
             The fixed right margin stops every description at the same line, clear of the price
             column, however wide that row's own price is. -->
        <div
            v-if="row.description"
            class="text-muval-gray-3 mt-1 break-words whitespace-pre-line"
            :class="[textSize, size === 'xs' ? 'pr-24' : 'pr-28']"
            data-testid="price-breakdown-row-description"
        >
            {{ row.description }}
        </div>
    </div>
</template>

<script setup lang="ts">
import type { PriceBreakdownRowData } from '@/composables/usePriceBreakdown';

/**
 * One row of a price breakdown: the label and figure side by side, and a line item's description
 * beneath them. Shared by the booking card (`sm`) and the checkout breakdown (`xs`).
 */
const props = defineProps({
    row: {
        type: Object as PropType<PriceBreakdownRowData>,
        required: true,
    },
    size: {
        type: String as PropType<'sm' | 'xs'>,
        required: false,
        default: 'sm',
    },
});

const textSize = computed(() => (props.size === 'xs' ? 'text-xs' : 'text-sm'));
</script>
